// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_is-1";
export var quotedThread = "_is-0";